import { AppQueryParams } from '@doda/common/src/constants/queryParams';
import {
  COMMA,
  COMPANY_DODA_DES_NM,
  COMPANY_DODA_PR_DES_NM,
  KEY_NM,
  KEY_PR_NM,
  STR_NO,
  SURASHU_N,
  WRRST_FLG_SET,
} from '@doda/common/src/constants/seo';
import {
  DetailOption,
  MetaText,
  findMetaTagInfo,
  concatString,
  createLocationStr,
  createTitleByManuscript,
} from '@doda/common/src/logics/metaTag';
import type { Tab } from '../../types/tab';

/**
 * 求人詳細のメタテキストを生成する
 * @param query
 * @param path
 * @param root0
 * @param initialTab
 * @returns title, description, keywords
 */
export const getMetaText = (
  query: AppQueryParams,
  path: string,
  {
    corporateName,
    occupationName,
    locations,
    summaries,
    wcnsId,
    htmlExists,
    isPriorityDisplay,
  }: DetailOption,
  initialTab: Tab
): MetaText => {
  const metaInfo = findMetaTagInfo(query, path);
  if (metaInfo) {
    const { settingFlg } = metaInfo;
    if (WRRST_FLG_SET === settingFlg) {
      let title = '';
      title = concatString(corporateName, occupationName, SURASHU_N);
      if (summaries && initialTab === 'pr') {
        // Pick Up!の場合、職種名は不要
        title = corporateName;
        // Pick Up!の場合、title先頭に求人要約1を追加
        title = concatString(summaries[0], title, SURASHU_N);
      } else {
        title = concatString(corporateName, occupationName, SURASHU_N);
      }

      if (locations?.length) {
        // 文字列生成createJobLocationsStr
        const locationStr = createLocationStr(locations);
        title = concatString(title, locationStr, SURASHU_N);
      }

      // 求人詳細画面のtitle タグを取得する
      const eoption = {
        tab: initialTab,
        message: query.msg ?? '',
        wcnsId: wcnsId ?? '',
        htmlExists: htmlExists ?? false,
        isPriorityDisplay: isPriorityDisplay ?? false,
      };
      title += createTitleByManuscript(eoption);

      // 求人詳細画面のdescription タグを取得
      let description = '';
      if (summaries && initialTab === 'pr') {
        // Pick Up!の場合、職種名は不要
        description = corporateName;
        // Pick Up!の場合、description先頭に求人要約1を追加
        description = concatString(description, COMPANY_DODA_PR_DES_NM, STR_NO);
        description = concatString(summaries[0], description, SURASHU_N);
      } else {
        description = concatString(corporateName, occupationName, SURASHU_N);
        description = concatString(description, COMPANY_DODA_DES_NM, STR_NO);
      }

      // MetaKey = 企業名,新着求人用職種名,
      // 未使用のため削除↓
      // 職種大分類１,職種中分類１,
      // 職種大分類２,職種中分類２,固定文言
      let keywords = '';
      if (summaries && initialTab === 'pr') {
        // Pick Up!の場合、職種名は不要
        keywords = corporateName;
        // Pick Up!の場合、keywordsの先頭に求人要約1を追加
        keywords = concatString(keywords, KEY_PR_NM, COMMA);
        keywords = concatString(summaries[0], keywords, COMMA);
      } else {
        keywords = concatString(corporateName, occupationName, COMMA);
        keywords = concatString(keywords, KEY_NM, COMMA);
      }

      return {
        title,
        description,
        keywords,
      };
    }
    return {
      title: metaInfo.title ?? '',
      description: metaInfo.description ?? '',
      keywords: metaInfo.keywords ?? '',
    };
  }
  return {
    title: '',
    keywords: '',
    description: '',
  };
};
